import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '@nexelem/utils';
import { ReactNode } from 'react';

const badgeVariants = cva('box-border inline-flex items-center justify-center rounded-full uppercase', {
  variants: {
    variant: {
      default: 'border border-border-primary text-text-secondary',
      highlighted: 'border border-border-highlight bg-surface-highlight text-text-brand-darker',
    },
    size: {
      medium: 'h-6 gap-1 px-3 text-s11-sb has-[span:empty]:pr-2 has-[svg]:pl-2 [&_svg]:h-4! [&_svg]:w-5!',
      large: 'h-9 gap-1.5 px-4 text-s14-sb [&_svg]:h-6.5! [&_svg]:w-6.5!',
      jumbo: 'h-12 gap-2 px-5 text-s14-sb [&_svg]:h-8! [&_svg]:w-8!',
    },
    smallLeftPadding: {
      true: '',
    },
  },
  compoundVariants: [
    {
      smallLeftPadding: true,
      size: 'medium',
      class: 'pl-0.25',
    },
    {
      smallLeftPadding: true,
      size: 'large',
      class: 'pl-1',
    },
    {
      smallLeftPadding: true,
      size: 'jumbo',
      class: 'pl-1.75',
    },
  ],
});

type BadgeVariants = VariantProps<typeof badgeVariants>;

type BadgeProps = BadgeVariants & {
  StartIcon?: ReactNode;
  children?: ReactNode;
  className?: string;
  limited?: boolean;
  onClick?: () => void;
};

export const Badge = ({
  children,
  variant = 'default',
  className,
  size = 'medium',
  limited,
  StartIcon,
  smallLeftPadding,
  onClick,
}: BadgeProps) => (
  <span className={cn(badgeVariants({ variant, size, smallLeftPadding }), className)} onClick={onClick}>
    {StartIcon}
    <span
      className={cn('text-nowrap empty:hidden', limited && 'max-w-[30ch] overflow-hidden text-nowrap text-ellipsis')}
    >
      {children}
    </span>
  </span>
);

Badge.displayName = 'Badge';
